<template>
  <div class="stock-card" @click="$emit('click')">
    <div class="stock-card__content">
      <div class="stock-card_img">
        <img src="../../../assets/img/profile.png" alt="Debtor Image">
      </div>
      <div class="stock-card_info">
        <h6 >{{ debtor.Name }} {{ debtor.Surname }}</h6>
        <h6 class="text-muted stock-card_company">Contact :{{ debtor.CellNumber }}</h6>
      </div>
    </div>
    <div class="stock-card__footer">
      <div class="stock-card_stock-type">
        <p class="mb-0 text-secondary">{{ `TPIN : ${debtor.vat}` }}</p>
      </div>
      <div><h6 class="stock-card-price"> {{ $utils.formatMoney(debtor.Balance) }}</h6></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DebtorListItem",
  beforeMount() {
  },
  props : {
    debtor : {
      type : Object,
      required : true
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  margin: 0;

}

.stock-card_company {
  font-size: 12px;
}

.stock-card {
  background: #fff;
  padding: 6px 15px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid #d2d2d2;

  &__content {
    display: flex;
    align-items: center;
    //margin-bottom: 5px;

    .stock-card_img {
      margin-right: 10px;

      img {
        height: 60px;
        width: 60px;
        opacity: 0.7;
        object-fit: contain;
        border-radius: 8px;
      }
    }

    .stock-card_info {
      flex: 1;

      .text-muted a {
        color: #777;
      }
    }
  }

  &__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .stock-card_stock-type {
      width: 60%;
    }

    .stock-card-price {
      font-weight: 700;
      color: #40434A;
    }
  }
}

.stock-label {
  display: inline-block;
  padding: 2px 12px;
  font-size: 10px;
  font-weight: 700;
  background: #f5f5f5;
  border: 1px solid #d2d2d2;
  border-radius: 5px;
  margin-right: 2px;
  color: #40434A;
}

h6, h4, p {
  margin: 0;
}
</style>